import ForceLight from '../components/ForceLight';
import Eyebrow from '../components/Eyebrow';
import Wordmark from '../components/Wordmark';

export default function LandingPage() {
  return (
    <ForceLight>
      <main className="shell shell-centred">
        <div className="landing-lockup rise">
          <Eyebrow accent>Client review</Eyebrow>
          <div className="mt-5"><Wordmark size="large" /></div>
          <p className="rise-subtle" style={{ animationDelay: '100ms' }}>Private review tools by Sheahan Studios</p>
        </div>
      </main>
    </ForceLight>
  );
}
